import { createContext, PropsWithChildren, useContext } from 'react';
import useAvailabilityCurrentUserController from './shared/hooks/currentUserController/useAvailabilityCurrentUserController';
import { AvailabilityCurrentUserContextValue } from './types';

type AvailabilityCurrentUserProviderProps = PropsWithChildren<{
  isAvailabilityEnabled: boolean;
}>;

const AvailabilityCurrentUserContext = createContext<AvailabilityCurrentUserContextValue | undefined>(undefined);

export const useAvailabilityCurrentUser = () => {
  const context = useContext(AvailabilityCurrentUserContext);

  if (!context) {
    throw new Error('useAvailabilityCurrentUser must be used inside AvailabilityCurrentUserProvider');
  }

  return context;
};

const AvailabilityCurrentUserProvider = ({ children, isAvailabilityEnabled }: AvailabilityCurrentUserProviderProps) => {
  const value = useAvailabilityCurrentUserController({ isAvailabilityEnabled });

  return <AvailabilityCurrentUserContext.Provider value={value}>{children}</AvailabilityCurrentUserContext.Provider>;
};

export default AvailabilityCurrentUserProvider;
